<article class="related-search sim-gallery">
  <div class="container">
    <div class="simmer-animation sim-heading"></div>
    <div class="row custome-set pb-3">
      <div
        class="music-grid-list col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 mb-4 pl-0 d-flex"
        *ngFor="let grid of [1, 2, 3, 4, 5, 6, 7, 8]"
      >
        <div
          class="simmer-animation series-img mr-2"
          style="min-width: 60px; padding-bottom: 0; min-height: auto"
        ></div>
        <div class="series-content w-100">
          <div
            class="simmer-animation w-75 simmer-animation sim-date mb-2"
          ></div>
          <div class="simmer-animation w-100 simmer-animation sim-date"></div>
        </div>
      </div>
    </div>
  </div>
</article>
